import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const logoClasses = {
  phrase: css`
    font-size: ${spacing(4)};
  `,
  gap: css`
    margin-block-end: ${spacing(1.625)};
  `,
  arrow: css`
    inline-size: ${spacing(5.125)};
    block-size: ${spacing(2.875)};
    margin-inline-end: ${spacing(0.5)};
  `,
  logo: css`
    inline-size: ${spacing(17)};
    block-size: ${spacing(4.875)};
  `,
}
